module.exports = __webpack_public_path__ + "img/XRP.9d1111b2.png";